import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'common/components';
import './index.css';

const PillList = props => {
  const { className, list, theme } = props;

  const renderPills = list.map((item, idx) =>
    item.hide ? null : (
      <li key={idx} className={'pilllist__item'}>
        <Button
          type="button"
          className="btn pilllist__btn"
          disabled={item.disabled}
          onClick={item.action}
        >
          {item.label}
        </Button>
      </li>
    )
  );

  const listCSS = classnames(
    'pilllist',
    className,
    theme && theme.map(css => `pilllist--${css}`).join(' ')
  );

  return <ul className={listCSS}>{renderPills}</ul>;
};

PillList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  theme: PropTypes.array,
};

export default PillList;



// WEBPACK FOOTER //
// ./src/common/components/PillList/index.js